<freud-card id="notifications-card" #card *ngIf="isOpen">
	<ng-container freudTemplateHeader>
		<div class="header zk-flex zk-justify-between zk-items-center">
			<p id="notifications-title" freud-typography fontType="h4Semibold1-5">
				{{ 'NOTIFICATIONS.CARD.TITLE' | translate }}
			</p>
			<span id="notifications-tooltip" freud-tooltip [tooltipLabel]="'NOTIFICATIONS.CARD.INFO' | translate" tooltipPosition="left">
				<span class="freud-icon freud-icon-info-circle freud-icon-md"></span>
			</span>	
		</div>
	</ng-container>

	<ng-container *ngIf="this.hasLoadedNotifications || hasErrors">
		<notifications-list (onNotificationHidden)="hideNotification($event)" *ngIf="hasNotifications()" [notifications]="notifications"></notifications-list>
		<notifications-not-found *ngIf="!hasNotifications() && !hasErrors" class="zk-flex zk-flex-col zk-gap-6 zk-items-center"></notifications-not-found>
		<notifications-error *ngIf="hasErrors" class="zk-flex zk-flex-col zk-gap-6 zk-items-center"></notifications-error>
	</ng-container>
	<ng-container *ngIf="!this.hasLoadedNotifications">
		<freud-loader class="zk-mb-6" size="lg"></freud-loader>
	</ng-container>

	<ng-container freudTemplatefooter>
		<div class="zk-flex zk-flex-col zk-gap-2 zk-items-center zk-justify-center">
			<freud-button *ngIf="hasNotifications() && !hasErrors" (click)="loadMoreNotifications()" [disabled]="notifications.length === totalNotifications" [loading]="isLoadingMoreNotifications" id="load-more-button" color="ghost">
				{{ 'NOTIFICATIONS.CARD.LOAD_MORE_BUTTON' | translate }}
			</freud-button>
			<freud-button #closeCard class="close-button" color="ghost">
				{{ 'NOTIFICATIONS.CARD.CLOSE_BUTTON' | translate }}
			</freud-button>
		</div>
    </ng-container>
</freud-card>